export default {
	name: 'queryBook',
	data() {
		return {
			search: '',
			state: 0,
			getData: {},
			books: '',
			pageIndex: 1,
			pageRows: 10,
			count: 0,
			ShopID:this.$store.state.user.ShopID
		};
	},
	created() {

		this.getData = function() {
			this.$request.request({
				url: 'books/searchBooksByState',
				data: {
					pageCount: this.pageRows,
					pageIndex: this.pageIndex,
					searchText: this.search,
					state: this.state,
					ShopID:this.ShopID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.books = res.books;
					this.count = res.count;
				}
			});
		}

	},
	methods: {

		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}

			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		checkbook() {
			return this.BooksName.length > 0 && this.BookBriefIntroduction.length > 0 && this.WriterName.length >
				0 &&
				this.ClassificationID >
				0 && this.BookRecommend.length > 0 && this.Tag.length > 0;
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		}
	},
	filters: {
		bookState(v) {
			if (v == 0) return '正常';
			if (v == 1) return '下架';
			if (v == 2) return '借出';
		}
	},
	activated() {
		this.getData();
	}

}
